import Repository from "./Repository";

const resource = "";
export default {

    updateGuest (payload) {
        return Repository.post(`${resource}/guest/update`, { payload });
    },
    getGuest (guest_id) {
        return Repository.get(`${resource}/guest/getid/${guest_id}`);
    },
    getGuestAid (aid) {
        return Repository.get(`${resource}/guest/getkunde/${aid}`);
    },
    getOldChats () {
        return Repository.get(`${resource}/guest/oldchats`);
    },





}
